// extracted by mini-css-extract-plugin
module.exports = {"heading-container":"dd31006766--heading-container--i7CFr","delete-button-container":"dd31006766--delete-button-container--v5t5X"};